import * as React from "react";
import styled, { css } from "styled-components";
import Menu from "components/bootstrap/Menu";
import { MenuAnchor } from "components/bootstrap/useClickToOpenMenu";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { MenuItem } from "components/bootstrap";
import Icon from "components/common/Icon";
const DropdownTrigger = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    line-height: inherit;
  `
);
export const DropdownCaret = styled(Icon)`
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
`;
const MenuItemLabel = styled.span(
  ({ $active }) => css`
    font-weight: ${$active ? "bold" : "inherit"};
  `
);
const HeaderActionsDropdown = ({
  children,
  label,
  activeSort = false,
  isSliceActive = false,
  onChangeSlicing,
  sliceColumnId = void 0,
  appSection = void 0,
  onSort = void 0,
  onHideColumn = void 0,
  opened = void 0,
  onOpenChange = void 0,
  anchorPosition = void 0,
  textAlign
}) => {
  var _a, _b;
  const sendTelemetry = useSendTelemetry();
  const hasActions = Boolean(onChangeSlicing || onSort || onHideColumn);
  const onToggleSlicing = () => {
    if (isSliceActive) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_REMOVED, {
        app_section: appSection,
        app_action_value: "slice-remove",
        event_details: { attribute_id: sliceColumnId }
      });
      return onChangeSlicing(void 0, void 0);
    }
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_COLUMN_SELECTED_HEADER, {
      app_section: appSection,
      app_action_value: "slice-column-header",
      event_details: { attribute_id: sliceColumnId }
    });
    return onChangeSlicing(sliceColumnId);
  };
  if (!hasActions) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(Menu, { shadow: "md", withinPortal: true, position: "bottom-start", opened, onChange: onOpenChange }, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(MenuAnchor, { style: { left: (_a = anchorPosition == null ? void 0 : anchorPosition.x) != null ? _a : 0, top: (_b = anchorPosition == null ? void 0 : anchorPosition.y) != null ? _b : 0 } })), /* @__PURE__ */ React.createElement(DropdownTrigger, { title: `Toggle ${label} actions` }, textAlign === "right" && /* @__PURE__ */ React.createElement(DropdownCaret, { name: "arrow_drop_down", size: "xs", className: "header-action" }), children, textAlign !== "right" && /* @__PURE__ */ React.createElement(DropdownCaret, { name: "arrow_drop_down", size: "xs", className: "header-action" })), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, onSort && /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => onSort(false), icon: "arrow_upward" }, /* @__PURE__ */ React.createElement(MenuItemLabel, { $active: activeSort === "asc" }, "Sort ascending")), onSort && /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => onSort(true), icon: "arrow_downward" }, /* @__PURE__ */ React.createElement(MenuItemLabel, { $active: activeSort === "desc" }, "Sort descending")), onSort && onChangeSlicing && /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), onChangeSlicing && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onToggleSlicing, icon: "surgical" }, isSliceActive ? "No slicing" : "Slice by values"), (onSort || onChangeSlicing) && onHideColumn && /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), onHideColumn && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onHideColumn, icon: "visibility_off" }, "Hide column")));
};
export default HeaderActionsDropdown;
